import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, IconButton, Popover, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import brgyList from '../../utils/geoData/barangay.json'
import cityList from '../../utils/geoData/city.json'
import provinceList from '../../utils/geoData/province.json'
import regionList from '../../utils/geoData/region.json'
import { AddressSelect } from './AddressSelect'

const getDefautlValues = address => {
  if (address === '' || address === undefined) {
    return undefined
  }
  const defaultValueArray = address.split(', ')
  const region = {
    label: defaultValueArray[0],
    code: regionList.find(reg => reg.region_name === defaultValueArray[0])
      ?.region_code
  }

  const province = {
    label: defaultValueArray[1],
    code: provinceList.find(
      prov =>
        prov.region_code === region.code &&
        prov.province_name === defaultValueArray[1]
    )?.province_code
  }

  const city = {
    label: defaultValueArray[2],
    code: cityList.find(
      ci =>
        ci.province_code === province.code &&
        ci.city_name === defaultValueArray[2]
    )?.city_code
  }

  const barangay = {
    label: defaultValueArray[3],
    code: brgyList.find(
      brgy =>
        brgy.city_code === city.code && brgy.brgy_name === defaultValueArray[3]
    )?.brgy_code
  }

  return {
    region,
    province,
    city,
    barangay
  }
}

export const AddressInput = ({
  onChange,
  value,
  name,
  defaultValue = '',
  hasError
}) => {
  const defaultValueObj = getDefautlValues(defaultValue)
  const [region, setRegion] = useState(defaultValueObj?.region)
  const [province, setProvince] = useState(defaultValueObj?.province)
  const [city, setCity] = useState(defaultValueObj?.city)
  const [brgy, setBrgy] = useState(defaultValueObj?.barangay)
  const [anchorEl, setAnchorEl] = React.useState(null)

  const onSelectRegion = region => {
    setProvince(undefined)
    setCity(undefined)
    setBrgy(undefined)
    setRegion(region)
  }

  const onSelectProvince = province => {
    setCity(undefined)
    setBrgy(undefined)
    setProvince(province)
  }

  const onSelectCity = city => {
    setBrgy(undefined)
    setCity(city)
  }

  const onSelectBrgy = brgy => {
    setAnchorEl(null)
    setBrgy(brgy)
  }

  useEffect(() => {
    const addressArray = [
      region?.label,
      province?.label,
      city?.label,
      brgy?.label
    ]
    onChange(addressArray.filter(n => n !== undefined).join(', '))
  }, [region, province, city, brgy])

  useEffect(() => {
    if (defaultValue !== '') {
      onChange(defaultValue)
    }
  }, [])

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <Box width='100%'>
      <TextField
        fullWidth
        onClick={handleClick}
        label='Address'
        value={value}
        name={name}
        InputLabelProps={{
          shrink: value !== undefined && value !== '' && value !== null
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <IconButton>
              <ExpandMoreIcon />
            </IconButton>
          )
        }}
        error={hasError}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        disablePortal
        PaperProps={{
          style: { width: anchorEl !== null ? anchorEl.offsetWidth : 500 }
        }}
      >
        <AddressSelect
          region={region}
          province={province}
          city={city}
          brgy={brgy}
          onSelectRegion={onSelectRegion}
          onSelectProvince={onSelectProvince}
          onSelectCity={onSelectCity}
          onSelectBrgy={onSelectBrgy}
        />
      </Popover>
    </Box>
  )
}
